import React from "react";
import { Routes, Route } from "react-router-dom";
import AppLayout from "./AppLayout";
import "./App.css";
import LandingPage from "./pages/LandingPage";
import RequireAuth from "./RequireAuth";

const App = () => {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route
        path="/app/*"
        element={
          <RequireAuth>
            <AppLayout />
          </RequireAuth>
        }
      />
    </Routes>
  );
};

export default App;
